import { createFileRoute } from '@tanstack/react-router';
import { IntegrationsTable } from '../../pages/platform/tenants/integrations/IntegrationsTable';

// Pestaña Integraciones del drill-down (credenciales M2M del tenant, DEC-RBAC-120 → 127). El
// tenantId sale del PATH, no del user logueado: las integraciones son datos del tenant, pero solo
// un usuario de plataforma las administra. El acceso ya está gateado por `platform.integration.view`
// en el sub-nav del shell ($tenantId.tsx); cada acción repite su Gate adentro y el backend re-enforza.
export const Route = createFileRoute(
    '/_authenticated/_layout/platform/tenants/$tenantId/integrations',
)({
    component: TenantIntegrations,
});

function TenantIntegrations() {
    const { tenantId } = Route.useParams();
    return <IntegrationsTable tenantId={tenantId} />;
}
